<div [formGroup]="form" class="form-group radio-btn-container">
  <label *ngIf="field?.label">{{ field.label }}{{ field.validation?.required ? '*' : '' }}</label>
  <app-info-icon
    [message]="field.infoIconMessage"
    *ngIf="field.infoIconMessage"
  ></app-info-icon>
  <div
    class="radio-btn-head"
    [ngClass]="{
      'flex-vertical': field.optionDirection === optionDirection.VERTICAL,
      'flex-horizontal': field.optionDirection === optionDirection.HORIZONTAL
    }"
  >
    <label
      *ngFor="let option of field.options"
      class="custom-checkbox custom-radio-lg"
      [ngClass]="{ 'cursor-disabled': field.disabled }"
    >
      {{ option.label }}
      <input
        type="radio"
        [formControlName]="field.name"
        [value]="option.value"
        [disabled]="field.disabled"
      />
      <span
        class="checkmark"
        [ngClass]="{
          'icon-liteicon-black-tick': option.value === form.get(field.name)?.value
        }"
      ></span>
      <p *ngIf="option?.sublabel">{{ option.sublabel }}</p>
    </label>
  </div>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
